import React from "react";

import { Outlet } from "react-router-dom";
import Header from "./Header";

function Layout() {
  return (
    <div className="relative flex flex-col min-h-screen">
      <Header />
      <div id="body" className="pt-[60px] ">
        <Outlet />
      </div>
    </div>
  );
}

export default Layout;
